import type { Dispatch, SetStateAction } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { EditorState } from "../connectorManagerHelpers";

export const BentoFields = ({
  editor,
  setEditor,
}: {
  editor: EditorState;
  setEditor: Dispatch<SetStateAction<EditorState>>;
}) => (
  <div className="space-y-3">
    <div className="space-y-2">
      <Label htmlFor="connector-bento-uuid">Bento site UUID</Label>
      <Input
        id="connector-bento-uuid"
        value={editor.bentoSiteUuid}
        onChange={(e) => setEditor((s) => ({ ...s, bentoSiteUuid: e.target.value }))}
        placeholder="00000000-0000-0000-0000-000000000000"
      />
      <p className="text-xs text-muted-foreground">
        Find this in Bento under Account → Your account → Site UUID.
      </p>
    </div>
    <div className="grid gap-2 sm:grid-cols-2">
      <div className="space-y-2">
        <Label htmlFor="connector-bento-pub">
          Publishable key {editor.connector ? "(leave blank to keep)" : ""}
        </Label>
        <Input
          id="connector-bento-pub"
          value={editor.bentoPublishableKey}
          onChange={(e) => setEditor((s) => ({ ...s, bentoPublishableKey: e.target.value }))}
          placeholder="bento-publishable-…"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="connector-bento-secret">
          Secret key {editor.connector ? "(leave blank to keep)" : ""}
        </Label>
        <Input
          id="connector-bento-secret"
          type="password"
          autoComplete="new-password"
          value={editor.secretValue}
          onChange={(e) => setEditor((s) => ({ ...s, secretValue: e.target.value }))}
          placeholder="Stored encrypted"
        />
      </div>
    </div>
    <p className="text-xs text-muted-foreground">
      Both keys come from Bento → Account → API keys. They are stored encrypted and used together for HTTP Basic auth.
    </p>
    <div className="grid gap-2 sm:grid-cols-2">
      <div className="space-y-2">
        <Label htmlFor="connector-bento-from-name">From name (optional)</Label>
        <Input
          id="connector-bento-from-name"
          value={editor.bentoFromName}
          onChange={(e) => setEditor((s) => ({ ...s, bentoFromName: e.target.value }))}
          placeholder="e.g. Excerptus"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="connector-bento-from-email">From email (optional)</Label>
        <Input
          id="connector-bento-from-email"
          type="email"
          value={editor.bentoFromEmail}
          onChange={(e) => setEditor((s) => ({ ...s, bentoFromEmail: e.target.value }))}
          placeholder="hello@example.com"
        />
        <p className="text-xs text-muted-foreground">
          Must be a verified author in Bento; otherwise Bento uses your default.
        </p>
      </div>
    </div>
  </div>
);
